'use strict';

exports.__esModule = true;
/*
 * This file is part of the nivo project.
 *
 * Copyright 2016-present, Raphaël Benitte.
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */
var DIRECTION_ROW = exports.DIRECTION_ROW = 'row';
var DIRECTION_COLUMN = exports.DIRECTION_COLUMN = 'column';

var ANCHOR_TOP = exports.ANCHOR_TOP = 'top';
var ANCHOR_TOP_RIGHT = exports.ANCHOR_TOP_RIGHT = 'top-right';
var ANCHOR_RIGHT = exports.ANCHOR_RIGHT = 'right';
var ANCHOR_BOTTOM_RIGHT = exports.ANCHOR_BOTTOM_RIGHT = 'bottom-right';
var ANCHOR_BOTTOM = exports.ANCHOR_BOTTOM = 'bottom';
var ANCHOR_BOTTOM_LEFT = exports.ANCHOR_BOTTOM_LEFT = 'bottom-left';
var ANCHOR_LEFT = exports.ANCHOR_LEFT = 'left';
var ANCHOR_TOP_LEFT = exports.ANCHOR_TOP_LEFT = 'top-left';
var ANCHOR_CENTER = exports.ANCHOR_CENTER = 'center';

var DIRECTION_LEFT_TO_RIGHT = exports.DIRECTION_LEFT_TO_RIGHT = 'left-to-right';
var DIRECTION_RIGHT_TO_LEFT = exports.DIRECTION_RIGHT_TO_LEFT = 'right-to-left';
var DIRECTION_TOP_TO_BOTTOM = exports.DIRECTION_TOP_TO_BOTTOM = 'top-to-bottom';
var DIRECTION_BOTTOM_TO_TOP = exports.DIRECTION_BOTTOM_TO_TOP = 'bottom-to-top';


//////////////////
// WEBPACK FOOTER
// ./~/@nivo/legends/lib/constants.js
// module id = 39
// module chunks = 168707334958949